import { render } from "./dash-lg.vue?vue&type=template&id=40bd451c"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/dash-lg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40bd451c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40bd451c', __exports__)) {
    api.reload('40bd451c', __exports__)
  }
  
  module.hot.accept("./dash-lg.vue?vue&type=template&id=40bd451c", () => {
    api.rerender('40bd451c', render)
  })

}


export default __exports__